module.exports = __webpack_public_path__ + "img/Restaurant4.d3719fe2.png";